
/**
 * Ensures unified naming for DB-native functions.
 */
// eslint-disable-next-line no-shadow
export type DBFunctionName = 'rate' | 'averageOverTime' | 'histogramQuantile'; // ToDo: extend
